import { render, staticRenderFns } from "./s3Record.vue?vue&type=template&id=63580460&"
import script from "./s3Record.vue?vue&type=script&lang=js&"
export * from "./s3Record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports